import { createFileRoute } from "@tanstack/react-router";
import { StorybookPage } from "../../../../pages/storybook-page";

export const Route = createFileRoute("/_auth/_frame/storybook/")({
  component: StorybookPage,
});
